var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MeasureComponent } from '../../measure/measure.component';
import { MeasureService } from '../../../services/measure/measure.service';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { InfluencerGroupsService } from '../../influencer-groups/influencer-groups.service';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { ModalService } from '../../../services/modal/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { PdfViewerService } from '../pdf-viewer.service';
import { CommonConstant, chartConfig } from '../../../app.constants';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { ReportSectionEnum } from '../../../../models/measure/report';
import { EventTrackerService } from '../../../services/event-tracker/event-tracker.service';
import { DateRange } from '../../../../models/date-range';
export var ServiceCounter;
(function (ServiceCounter) {
    ServiceCounter[ServiceCounter["init"] = 0] = "init";
    ServiceCounter[ServiceCounter["max"] = 8] = "max";
    ServiceCounter[ServiceCounter["renderTimeout"] = 10000] = "renderTimeout";
})(ServiceCounter || (ServiceCounter = {}));
var MeasurePdfViewerComponent = /** @class */ (function (_super) {
    __extends(MeasurePdfViewerComponent, _super);
    function MeasurePdfViewerComponent(measureService, campaignService, influencerGroupService, referenceDataService, translate, userService, modalService, router, route, location, pdfViewerService, eventTracker, pdfExportService, currentRoute) {
        var _this = _super.call(this, measureService, campaignService, influencerGroupService, referenceDataService, translate, userService, modalService, router, route, location, pdfViewerService, pdfExportService, eventTracker) || this;
        _this.pdfExportService = pdfExportService;
        _this.currentRoute = currentRoute;
        _this.specialReports = [ReportSectionEnum.ROI_REPORT, ReportSectionEnum.OONA_REPORT, ReportSectionEnum.INTERACTION_REPORT, ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT];
        _this.industryDrillDownReportPieSize = chartConfig.industryDrillDownChart.chartSize;
        return _this;
    }
    MeasurePdfViewerComponent.prototype.ngOnInit = function () {
        var _this = this;
        // disable highchart animation
        var highcharts = require('highcharts');
        highcharts.setOptions({
            chart: {
                animation: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        });
        _super.prototype.ngOnInit.call(this);
        this.currentRoute.queryParams.subscribe(function (params) {
            var selectedDateRange = new DateRange();
            selectedDateRange.startDate = params.from;
            selectedDateRange.endDate = params.to;
            _this.previousDate = selectedDateRange.formattedStartDate;
            _this.currentDate = selectedDateRange.formattedEndDate;
            if (params.orderBy) {
                _this.selectedBestPerformingInfluencerOrder = params.orderBy;
                _this.reportCriteria.orderBy = params.orderBy;
            }
        });
        this.pdfExportService.triggerIncrementReportReady.subscribe(function (numberReportReady) {
            console.log("ready: " + numberReportReady + " - total module: " + _this.listModuleForPdf.length);
            var totalModule = _this.listModuleForPdf.length;
            if (numberReportReady === totalModule) {
                console.log(' ***************************************** ALL REPORT READY TO EXPORT PDF *****************************************');
                setTimeout(function () {
                    _this.pdfReady();
                }, 200);
            }
        });
    };
    MeasurePdfViewerComponent.prototype.pdfReady = function () {
        if (window && typeof window.pdfReady === 'function') {
            window.pdfReady();
        }
    };
    MeasurePdfViewerComponent.prototype.isHiddenSection = function (section) {
        var sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);
        var data = sectionData ? sectionData.value.data : undefined;
        switch (section) {
            case ReportSectionEnum.TIMELINE_REPORT:
            case ReportSectionEnum.LOCAL_AREAS_REPORT:
            case ReportSectionEnum.MENTION_TIMELINE_REPORT:
            case ReportSectionEnum.EXPOSURE_KPI_REPORT:
            case ReportSectionEnum.EXPOSURE_PLATFORM_REPORT:
            case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
            case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
            case ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT:
            case ReportSectionEnum.ROI_REPORT:
                return data && data.length < 1;
            case ReportSectionEnum.BEST_EXPOSURE_REPORT:
                return data && data.bestPerformanceExposures.length < 1 && data.topExposure.length < 1;
            case ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT:
            case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
            case ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT:
                return data === undefined;
            case ReportSectionEnum.INTERACTION_REPORT:
                return data && data.kpi === undefined && data.posts.length < 1;
            default:
                return false;
        }
    };
    MeasurePdfViewerComponent.prototype.getReportData = function (section, sectionIndex) {
        var sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);
        if (!sectionData) {
            return null;
        }
        if (this.specialReports.indexOf(section) < 0) {
            return sectionData ? sectionData.value.data : undefined;
        }
        switch (section) {
            case ReportSectionEnum.ROI_REPORT:
                var roiComponentIndex = this.getReportComponentIndex(section, sectionIndex);
                return Object.assign({}, sectionData.value.data, {
                    kpis: roiComponentIndex > 0 ? null : sectionData.value.data.kpis,
                    datas: this.getInfluencerRoiList(roiComponentIndex, sectionData.value.data.datas)
                });
            case ReportSectionEnum.OONA_REPORT:
                var oonaComponentIndex = this.getReportComponentIndex(section, sectionIndex);
                var startOonaDataIndex = oonaComponentIndex * CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE;
                return Object.assign({}, sectionData.value.data, {
                    data: sectionData.value.data.data.slice(startOonaDataIndex, startOonaDataIndex + CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE)
                });
            case ReportSectionEnum.INTERACTION_REPORT:
                var interComponentIndex = this.getReportComponentIndex(section, sectionIndex);
                return Object.assign({}, sectionData.value.data, {
                    kpi: interComponentIndex > 0 ? null : sectionData.value.data.kpi,
                    posts: this.getInfluencerInteractionList(interComponentIndex, sectionData.value.data.posts)
                });
            case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
                sectionData.value.data.allTopicCharts = sectionData.value.data.allTopicCharts.slice(0, CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE);
                return sectionData.value.data;
            default:
                return null;
        }
    };
    MeasurePdfViewerComponent.prototype.getInfluencerRoiList = function (componentIndex, fullInfluencerList) {
        var limitedInfluencerList = fullInfluencerList.slice(0, this.numberOfPostInRoiPdf);
        if (componentIndex === 0) {
            return limitedInfluencerList.slice(0, CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE - 2);
        }
        else {
            var startDataIndex = componentIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE - 2;
            return limitedInfluencerList.slice(startDataIndex, startDataIndex + CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE);
        }
    };
    MeasurePdfViewerComponent.prototype.getInfluencerInteractionList = function (componentIndex, fullInfluencerList) {
        if (componentIndex === 0) {
            return fullInfluencerList.slice(0, CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE - 2);
        }
        else {
            var startDataIndex = componentIndex * CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE - 2;
            return fullInfluencerList.slice(startDataIndex, startDataIndex + CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE);
        }
    };
    MeasurePdfViewerComponent.prototype.getReportComponentIndex = function (section, sectionIndex) {
        if (this.specialReports.indexOf(section) < 0) {
            return null;
        }
        switch (section) {
            case ReportSectionEnum.ROI_REPORT:
                var roiComponentIndex = this.roiIndexMapping.get(sectionIndex);
                return roiComponentIndex ? roiComponentIndex : 0;
            case ReportSectionEnum.OONA_REPORT:
                var oonaComponentIndex = this.oonaIndexMapping.get(sectionIndex);
                return oonaComponentIndex ? oonaComponentIndex : 0;
            case ReportSectionEnum.INTERACTION_REPORT:
                var interactionComponentIndex = this.interactionIndexMapping.get(sectionIndex);
                return interactionComponentIndex ? interactionComponentIndex : 0;
            default:
                return null;
        }
    };
    Object.defineProperty(MeasurePdfViewerComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    return MeasurePdfViewerComponent;
}(MeasureComponent));
export { MeasurePdfViewerComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/measure-pdf-viewer/measure-pdf-viewer.component.ts.pre-build-optimizer.js